@if (scrollingInfo$ | async; as scrollingInfo) {
  <div
    class="bars {{ size }} {{ visibility }}"
    [class.theme-light]="theme === 'light'"
    [class.scrolling]="scrollingInfo.condition">
    @if (hasVerticalBar) {
      <div class="bar bar_vertical" [ngClass]="{ 'bar_has-horizontal': hasHorizontalBar }">
        <div
          class="thumb"
          appDraggableScrollbar
          [draggable]="'vertical'"
          [style.height.%]="verticalSize"
          [style.top.%]="verticalPosition"
          (dragged)="onVertical($event)"></div>
      </div>
    }
    @if (hasHorizontalBar) {
      <div class="bar bar_horizontal" [ngClass]="{ 'bar_has-vertical': hasVerticalBar }">
        <div
          class="thumb"
          appDraggableScrollbar
          [draggable]="'horizontal'"
          [style.width.%]="horizontalSize"
          [style.left.%]="horizontalPosition"
          (dragged)="onHorizontal($event)"></div>
      </div>
    }
  </div>
}

<div class="scroll-content">
  <ng-content></ng-content>
</div>
